import React, { useState} from 'react';
import {slide as Menu} from 'react-burger-menu'
import './Style/SideMenu.css'
import './Style/GlobalVariables.css'
import GlobalVariables from "./GlobalVariables";
import GlobalNames from "./GlobalNames";

const SideMenu = () => {

    const [refresh, setrefresh] = useState(true)

    const saveFile = async (data) => {
        const fileHandler = await window.showSaveFilePicker({
            types: [
                {
                    accept: {
                        'data/*': ['.vars']
                    }
                }
            ],
        })


        const variables = JSON.parse(localStorage.getItem("variables"))//,JSON.parse(localStorage.getItem("names"))]

        const stream = await fileHandler.createWritable();
        await stream.write(JSON.stringify(variables))
        await stream.close()
    }


    const loadFile = async ()=>{
        const [Filehand] = await window.showOpenFilePicker({
            types: [
                {
                    accept: {
                        'data/*': ['.vars']
                    }
                }
            ]
        })

        const fl = await Filehand.getFile()

        const text = await fl.text()

        const vars = await JSON.parse(text)

        localStorage.setItem("variables", JSON.stringify(vars))
        // localStorage.setItem("names", JSON.stringify(arr[1]))
       await setrefresh(false)
        setTimeout(() => {
            setrefresh(true)
        }, 1)
    }

    // useEffect(()=>{
    //         localStorage.setItem("variables", '')
    //         localStorage.setItem("names",'')
    //     }
    //     ,[]
    // )
    return (

            <Menu >
                <button onClick={saveFile}
                    className="backBatton" style={{
                        position:"absolute",
                    top:"10",
                       left:"0",
                    marginTop:"-35px",
                   marginLeft:"70px"
                }}>
                  Save
                </button>
                <button onClick={loadFile}
                    className="backBatton"style={{
                    position:"absolute",
                    top:"10",
                    left:"0",
                    marginTop:"-35px",
                    marginLeft:"160px"
                }}>
                    Load
                </button>

                {refresh &&
                    <>
                    <GlobalVariables/>
                    {/*<GlobalNames/>*/}
                    </>
                }


                {/*<a id="home" className="menu-item">     </a>*/}
                {/*<a id="about" className="menu-item" href="/about">About</a>*/}
                {/*<a id="contact" className="menu-item" href="/contact">Contact</a>*/}
                {/*<a onClick={showSettings} className="menu-item--small" href="">Settings</a>*/}
            </Menu>

    );
};

export default SideMenu;